import { NameDto } from 'api/Common/Types'
import { TokenizedCardStatus } from 'api/NPayments/Types/TokenizedCardDetails'

export const getTokenizedCardStatusName = (status: NameDto): string => {
  if (status.id === TokenizedCardStatus.CLOSED) {
    return 'Closed / Stolen'
  }

  return status.name
}

export const formatCardExpirationDate = (expirationDate: string): string => {
  if (!expirationDate) {
    return ''
  }

  const valueWithoutSpaces = expirationDate.replace(/\s/g, '')
  const [month, year] = valueWithoutSpaces.split('/')

  if (month && year) {
    return `${month} / ${year}`
  }

  return expirationDate
}

export const formatMaskedCardNumber = (maskedCardNumber: string): string => {
  if (!maskedCardNumber) {
    return ''
  }

  return maskedCardNumber.replace('...', '****')
}
